module.exports = __webpack_public_path__ + "media/components/assets/icons/default_profile2-3dc0100e588dcda24fe1be0a296fb215.svg";